module.exports = __webpack_public_path__ + "front/img/18_a.08070cb3.png";